import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import Icon from '../../../Atoms/Icon'
import { Text } from '../../../Atoms/Typography'
import Button from '../../../Atoms/Button'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  padding: ${theme.gutterUnit}px;
`

export default class SignOffButton extends PureComponent {
  render () {
    const { minimised, onSubmit } = this.props
    return (
      <Container minimised={minimised}>
        <Button secondary rounded vertical={minimised} onPress={onSubmit}>
          <Icon size={minimised ? 'm' : 's'} name='tick' colour={theme.colours.black} />
          <Text
            size={minimised ? 'xxs' : 'm'} bold overrides={{
              marginLeft: minimised ? 0 : 1 * theme.gutterUnit
            }}
          >SIGN OFF
          </Text>
        </Button>
      </Container>
    )
  }
}
